import { render, staticRenderFns } from "./attList.vue?vue&type=template&id=1a88e8be&"
import script from "./attList.vue?vue&type=script&lang=js&"
export * from "./attList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports